// Environment access that works in BOTH the browser bundle and plain Node.
//
// Vite replaces `import.meta.env.VITE_*` at build time; Node has no such thing,
// so reading it there throws. Resolving once here lets the real data layer
// (api.supabase.js, supabase.js) be imported by Node scripts — which is what
// makes `npm run doctor` able to test the actual production code path rather
// than a reimplementation of it.
const viteEnv = typeof import.meta !== 'undefined' ? import.meta.env : undefined;

export const ENV = viteEnv ?? (typeof process !== 'undefined' ? process.env : {});
